import { render, staticRenderFns } from "./addressListCard.vue?vue&type=template&id=4fc05f05&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./addressListCard.vue?vue&type=style&index=0&id=4fc05f05&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc05f05",
  null
  
)

export default component.exports